module.exports = __webpack_public_path__ + "static/media/img_profile_empty.47f16fe2.svg";